module.exports = __webpack_public_path__ + "static/026-5497841dc1c4b78e5f3e75ec485f6a91.jpg";